export default __webpack_public_path__ + "static/media/skirt_1@2x.7552466f.jpg";